var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKioskIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.15 0C19.5976 0 19.9913 0.297713 20.1129 0.728516L22.6256 9.62988C22.7106 9.93114 22.6503 10.2552 22.4615 10.5049C22.2725 10.7545 21.9768 10.9014 21.6637 10.9014H16.1285V23.9229H18.9479C19.5 23.923 19.9478 24.3707 19.9479 24.9229C19.9479 25.475 19.5 25.9227 18.9479 25.9229H4.26523C3.71307 25.9227 3.26523 25.475 3.26523 24.9229C3.26528 24.3707 3.7131 23.923 4.26523 23.9229H7.06406V10.9014H0.99961C0.686478 10.9013 0.390731 10.7546 0.201758 10.5049C0.013025 10.2552 -0.0472479 9.9311 0.0376956 9.62988L2.55039 0.728516C2.672 0.297795 3.06574 0.000112822 3.51328 0H19.15ZM9.06406 23.9229H14.1285V10.9014H9.06406V23.9229ZM2.3209 8.90137H20.3424L18.3941 2H4.26914L2.3209 8.90137Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKioskIcon);
export default __webpack_public_path__ + "static/media/KioskIcon.26d59b091d2eaabec9c6df0782b656b3.svg";
export { ForwardRef as ReactComponent };